const TOOLTIP_ORIGINAL_TITLE = 'data-otello-tooltip-original-title';
const TOOLTIP_MANAGED = 'data-otello-tooltip-managed';

const resolveTooltipContent = (value) => {
  if (value === null || value === undefined || value === false) return '';

  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }

  if (typeof value === 'object') {
    const content = value.content || value.title || value.text;
    if (content === null || content === undefined || content === false) {
      return '';
    }
    return String(content);
  }

  return String(value);
};

const cacheOriginalTitle = (el) => {
  if (el.hasAttribute(TOOLTIP_ORIGINAL_TITLE)) return;

  const originalTitle = el.getAttribute('title');
  if (originalTitle !== null) {
    el.setAttribute(TOOLTIP_ORIGINAL_TITLE, originalTitle);
  }
};

const applyTooltip = (el, binding) => {
  cacheOriginalTitle(el);

  const content = resolveTooltipContent(binding.value);
  if (!content) {
    el.removeAttribute('title');
    el.removeAttribute('aria-label');
    el.removeAttribute(TOOLTIP_MANAGED);
    return;
  }

  el.setAttribute('title', content);
  el.setAttribute('aria-label', content);
  el.setAttribute(TOOLTIP_MANAGED, 'true');
};

const removeTooltip = (el) => {
  if (el.getAttribute(TOOLTIP_MANAGED) !== 'true') return;

  const originalTitle = el.getAttribute(TOOLTIP_ORIGINAL_TITLE);
  if (originalTitle !== null) {
    el.setAttribute('title', originalTitle);
  } else {
    el.removeAttribute('title');
  }

  el.removeAttribute('aria-label');
  el.removeAttribute(TOOLTIP_MANAGED);
  el.removeAttribute(TOOLTIP_ORIGINAL_TITLE);
};

export default {
  beforeMount: applyTooltip,
  updated: applyTooltip,
  unmounted: removeTooltip,
};
